import { useEffect, useState } from 'react';
import { clearPendingPurchase, readPendingPurchase } from './purchase/pendingPurchase';

/**
 * The checkout cancel-return route (/purchase/cancelled): the provider sent the buyer back
 * without completing. A normal outcome — no money moved — so the pending purchase is dropped.
 */
export function PurchaseCancelledPanel({ onBackToShop }: { onBackToShop: () => void }) {
  const [purchase] = useState(() => readPendingPurchase());

  // A cancelled checkout is over: drop the pending purchase so the success page cannot replay it.
  useEffect(() => {
    clearPendingPurchase();
  }, []);

  return (
    <section>
      <h2>Checkout cancelled</h2>

      {purchase === null ? (
        <p>The provider sent you back without completing a purchase.</p>
      ) : (
        <p>
          The <strong>{purchase.accessId}</strong> purchase at <strong>{purchase.tenantId}</strong>{' '}
          was not completed.
        </p>
      )}

      <p>Cancelling at the provider is a normal checkout outcome — no money moved.</p>

      <p>
        <button onClick={onBackToShop}>Back to the shop</button>
      </p>
    </section>
  );
}
